import axios from "axios";
import { IBookableResource } from "../interfaces/BookableResources";
import { Get, Post, Delete, Put } from "./apiHelper";

const bookableResourcesRoot = "/api/bookableResources";

export async function postBookableResource(
  bookableResource: IBookableResource
): Promise<IBookableResource> {
  const response = await Post(`${bookableResourcesRoot}`, bookableResource, true);
  return response.data as IBookableResource;
}

export async function updateBookableResource(
  bookableResource: IBookableResource
): Promise<IBookableResource> {
  const response = await Put(
    `${bookableResourcesRoot}/${bookableResource.id}`,
    bookableResource,
    true
  );
  return response.data as IBookableResource;
}

export async function getBookingResources(): Promise<Array<IBookableResource>> {
  const response = await Get(`${bookableResourcesRoot}`, true);
  return response.data as Array<IBookableResource>;
}

export async function deactivateBookableResource(id: number): Promise<unknown> {
  const response = await Delete(`${bookableResourcesRoot}/${id}`, true);
  return response.data;
}

export async function getMappedResourceNames(): Promise<Array<unknown>> {
  const response = await Get(`/api/mappedNames`, true);
  return response.data as Array<unknown>;
}

export const getS3UploadPostData = async (fileName: string): Promise<unknown> => {
  const response = await Post(`${bookableResourcesRoot}/profileImage`, { fileName });
  return response.data;
};

export const uploadIconImage = async (
  bookableResource: IBookableResource,
  pictureData: Blob
): Promise<unknown> => {
  const createUpdateResponse = bookableResource.id
    ? await updateBookableResource(bookableResource)
    : await postBookableResource(bookableResource);

  const fileName = `${createUpdateResponse.id}.${pictureData.type.split("/")[1]}`;
  const postData = (await getS3UploadPostData(fileName)) as {
    id: number;
    data: Record<string, unknown> & { fields: Record<string, string>; url: string };
  };
  const s3FileName = `${postData.id}/${fileName}`;

  const formData = new FormData();

  Object.entries(postData.data.fields).forEach(([key, value]) => {
    formData.append(key, value);
  });

  formData.append("file", pictureData, s3FileName);

  const imageResponse = await axios.post(postData.data.url, formData);

  const response = await updateBookableResource({
    ...createUpdateResponse,
    details: {
      ...createUpdateResponse.details,
      iconUrl: imageResponse.headers.location
    }
  });

  return response;
};
